var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:`mdi ${_vm.icon}`,style:({ fontSize: _vm.size })})
}
var staticRenderFns = []

export { render, staticRenderFns }